<template>
  <div id="unitMeasureManagement" class="h-full">
    <!-- 新增单位类别弹窗-->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="unitTypeDialog"
      :title="unitTypeTitle"
      @close="closeUnitTypeDialog"
      class="mini-dialog"
      v-dialogDrag
    >
      <el-form
        :model="unitTypeForm"
        :rules="currentLang === 'zh' ? unitTypeRules : unitTypeEnRules"
        ref="unitTypeForm"
        label-width="150px"
      >
        <el-form-item :label="`${$t('seqNo')}`" prop="seqNo">
          <el-input-number
            v-model="unitTypeForm.seqNo"
            :controls="false"
            :disabled="unitTypeTitle === $t('viewUnitClass')"
            class="!w-280px"
            clearable
          ></el-input-number>
        </el-form-item>
        <el-form-item :label="`${$t('unitClassCode')}`" prop="code">
          <el-input
            v-model.trim="unitTypeForm.code"
            clearable
            data-cy="dicName"
            :readonly="unitTypeTitle === $t('viewUnitClass')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="`${$t('unitClassName')}`" prop="name">
          <el-input
            v-model.trim="unitTypeForm.name"
            clearable
            data-cy="dicDescription"
            :readonly="unitTypeTitle === $t('viewUnitClass')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer tc" v-if="unitTypeTitle !== $t('viewUnitClass')">
        <el-button
          type="primary"
          size="small"
          :loading="leftBtnLoading"
          @click="saveUnitTypeData"
          >{{ $t('save') }}</el-button
        >
        <el-button size="small" @click="closeUnitTypeDialog">{{ $t('cancel') }}</el-button>
      </div>
    </el-dialog>

    <!-- 新增单位弹窗-->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="unitDialog"
      :title="unitTitle"
      @close="closeUnitDialog"
      class="mini-dialog"
      v-dialogDrag
    >
      <el-form
        :model="unitForm"
        :rules="currentLang === 'zh' ? unitRules : unitEnRules"
        ref="unitForm"
        label-width="150px"
      >
        <el-form-item :label="`${$t('seqNo')}`" prop="seqNo">
          <el-input-number
            v-model="unitForm.seqNo"
            :controls="false"
            class="!w-280px"
            :disabled="unitTitle === $t('viewUnit')"
            clearable
          ></el-input-number>
        </el-form-item>
        <el-form-item :label="`${$t('unitCode')}`" prop="code">
          <el-input
            v-model.trim="unitForm.code"
            :readonly="unitTitle === $t('viewUnit')"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="`${$t('unitName')}`" prop="name">
          <el-input
            auto-complete="off"
            :readonly="unitTitle === $t('viewUnit')"
            clearable
            v-model.trim="unitForm.name"
            data-cy="dicDetailName"
          ></el-input>
        </el-form-item>
        <el-form-item :label="`${$t('unitSymbol')}`" prop="symbol">
          <el-input
            v-model.trim="unitForm.symbol"
            clearable
            :readonly="unitTitle === $t('viewUnit')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer tc" v-if="unitTitle !== $t('viewUnit')">
        <el-button type="primary" size="small" :loading="rightBtnLoading" @click="saveUnitData">{{
          $t('save')
        }}</el-button>
        <el-button size="small" @click="closeUnitDialog">{{ $t('cancel') }}</el-button>
      </div>
    </el-dialog>

    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <div class="h-full">
        <el-row type="flex" align="middle">
          <selectStandardId @updateStandardId="updateStandardId" />
          <el-input
            size="small"
            clearable
            v-model.trim="keyword"
            :placeholder="`${$t('pleaseEnterCodeOrName')}`"
            class="ml-10px w-200px"
          ></el-input>
          <el-button size="small" class="ml-10px" type="primary" @click="initLeftData">{{
            $t('search')
          }}</el-button>
          <el-button
            type="primary"
            size="small"
            @click="leftDataActions"
            class="ml-10px"
            :disabled="!$hasAccess('create')"
            >{{ $t('createUnitClass') }}</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="rightDataActions"
            class="ml-10px"
            :disabled="!$hasAccess('create')"
            >{{ $t('createUnit') }}</el-button
          >
          <el-button
            size="small"
            @click="exportFile"
            class="ml-10px"
            :disabled="!$hasAccess('export')"
            >{{ $t('export') }}</el-button
          >
          <el-button
            size="small"
            @click="importFile"
            class="ml-10px"
            :disabled="!$hasAccess('import')"
            >{{ $t('import') }}</el-button
          >
        </el-row>
        <el-row type="flex" :gutter="20" class="mt-20px" style="height: calc(100% - 56px)">
          <el-col :span="12" class="h-full">
            <el-table
              :data="leftTableData"
              highlight-current-row
              v-loading="leftLoading"
              border
              @row-click="clickRightTableRow"
              height="calc(100% - 48px)"
              stripe
              ref="leftTable"
            >
              <el-table-column
                width="75"
                prop="seqNo"
                sortable
                :label="`${$t('seqNo')}`"
              ></el-table-column>
              <el-table-column
                prop="code"
                sortable
                :label="`${$t('unitClassCode')}`"
              ></el-table-column>
              <el-table-column
                prop="name"
                sortable
                :label="`${$t('unitClassName')}`"
              ></el-table-column>
              <el-table-column prop="flag" :label="`${$t('operate')}`" width="200">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click.stop="viewUnitType(scope.row.id)"
                    :disabled="!$hasAccess('read')"
                    >{{ $t('view') }}</el-button
                  >
                  <el-button
                    size="mini"
                    @click.stop="editUnitType(scope.row.id)"
                    :disabled="!$hasAccess('update')"
                    >{{ $t('edit') }}</el-button
                  >
                  <el-button
                    size="mini"
                    @click.stop="deleteUnitType(scope.row.id)"
                    :disabled="!$hasAccess('delete')"
                    >{{ $t('delete') }}</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="mt-20px"
              background
              @current-change="unitTypeHandleCurrentChange"
              @size-change="unitTypeHandleSizeChange"
              :current-page.sync="unitTypePageNo"
              :page-size="unitTypePageSize"
              :page-sizes="$pageSizeAll"
              layout="->, total, sizes, prev, pager, next"
              :total="unitTypeRecordCount"
            ></el-pagination>
          </el-col>
          <el-col :span="12" class="h-full">
            <el-table
              height="calc(100% - 48px)"
              :data="rightTableData"
              ref="rightTable"
              highlight-current-row
              v-loading="rightLoading"
              border
              stripe
            >
              <el-table-column
                width="75"
                prop="seqNo"
                sortable
                :label="`${$t('seqNo')}`"
              ></el-table-column>
              <el-table-column prop="code" sortable :label="`${$t('unitCode')}`"></el-table-column>
              <el-table-column prop="name" sortable :label="`${$t('unitName')}`"></el-table-column>
              <el-table-column
                prop="symbol"
                sortable
                :label="`${$t('unitSymbol')}`"
              ></el-table-column>
              <el-table-column :label="`${$t('operate')}`" width="200">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="viewUnit(scope.row.id)"
                    :disabled="!$hasAccess('read')"
                    >{{ $t('view') }}</el-button
                  >
                  <el-button
                    size="mini"
                    @click="editUnit(scope.row.id)"
                    :disabled="!$hasAccess('update')"
                    >{{ $t('edit') }}</el-button
                  >
                  <el-button
                    size="mini"
                    @click="deleteUnit(scope.row.id)"
                    :disabled="!$hasAccess('delete')"
                    >{{ $t('delete') }}</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="mt-20px"
              background
              @current-change="unitHandleCurrentChange"
              @size-change="unitHandleSizeChange"
              :current-page.sync="unitPageNo"
              :page-size="unitPageSize"
              :page-sizes="$pageSizeAll"
              layout="->, total, sizes, prev, pager, next"
              :total="unitRecordCount"
            ></el-pagination>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <!-- 上传组件 -->
    <wiz-upload-file
      v-dialogDrag
      @refreshList="initLeftData"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
    ></wiz-upload-file>
  </div>
</template>
<script type="text/babel">
import fnMixin from '@/assets/js/fnMixins'
import unitMeasureservice from '@/services/unitMeasureservice'
import CommonService from '@/services/Common'
import selectStandardId from '../../components/selectStandardId'

export default {
  name: 'dictionaryManagement',
  components: { selectStandardId },
  mixins: [fnMixin],
  data() {
    return {
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      standardId: localStorage.getItem('standardId'),
      keyword: '',
      leftTableData: [{ id: 1 }],
      unitTypeTitle: this.$t('createUnitClass'),
      leftLoading: false,
      unitTypeRecordCount: 0,
      unitTypePageNo: 1,
      unitTypePageSize: 15,
      unitTypeDialog: false,
      unitTypeForm: { seqNo: '', code: '', name: '' },
      unitTypeRules: {
        code: [{ required: true, message: this.$t('unitClassCodeCanNotBeNull'), trigger: 'blur' }],
        name: [{ required: true, message: this.$t('unitClassNameCanNotBeNull'), trigger: 'blur' }],
      },
      unitTypeEnRules: {
        code: [{ required: true, message: this.$t('unitClassCodeCanNotBeNull'), trigger: 'blur' }],
        name: [{ required: true, message: this.$t('unitClassNameCanNotBeNull'), trigger: 'blur' }],
      },
      leftBtnLoading: false,
      selectedUnitTypeId: '',
      unitTitle: this.$t('createUnit'),
      rightLoading: false,
      rightTableData: [{ id: 0 }],
      unitRecordCount: 0,
      unitPageNo: 1,
      unitPageSize: 15,
      unitDialog: false,
      unitForm: {
        seqNo: '',
        name: '',
        code: '',
        symbol: '',
      },
      unitRules: {
        code: [{ required: true, message: this.$t('unitCodeCanNotBeNull'), trigger: 'blur' }],
        name: [{ required: true, message: this.$t('unitNameCanNotBeNull'), trigger: 'blur' }],
        symbol: [{ required: true, message: this.$t('unitSymbolCanNotBeNull'), trigger: 'blur' }],
      },
      unitEnRules: {
        code: [{ required: true, message: this.$t('unitCodeCanNotBeNull'), trigger: 'blur' }],
        name: [{ required: true, message: this.$t('unitNameCanNotBeNull'), trigger: 'blur' }],
        symbol: [{ required: true, message: this.$t('unitSymbolCanNotBeNull'), trigger: 'blur' }],
      },
      rightBtnLoading: false,
    }
  },
  async created() {
    if (this.standardId) {
      this.initLeftData()
    }
  },
  activated() {
    this.standardId = localStorage.getItem('standardId')
  },
  computed: {
    currentLang() {
      return this.$store.getters['System/currentLang']
    },
  },
  methods: {
    // 导入
    importFile() {
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    // 下载导入模板
    async exportTemplate() {
      const res = await CommonService.downloadTemplateCommon({
        reqUrl: 'std/StdUnitType/download_import_template?filter_attribute_group=1',
      })
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '度量单位导入模板.xlsx',
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append(key, value)
      })
      const res = await unitMeasureservice.upload(formData)
      if (res) {
        this.uploadFileProps.active = 2
        this.downLoadBlob({
          name: '度量单位导入明细.xlsx',
          data: res,
        })
        this.initLeftData()
      }
      this.uploadFileProps.btnLoading = false
    },
    // 更新标准id
    updateStandardId(val) {
      this.standardId = val
      this.initLeftData()
    },
    // 导出
    async exportFile() {
      const res = await unitMeasureservice.exportFile({
        standardId: this.standardId,
        filter: this.keyword,
        unitTypeIds: this.selectedUnitTypeId ? [this.selectedUnitTypeId] : [],
      })
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '度量单位导出结果.xlsx',
          data: res,
        })
      }
    },
    async initLeftData() {
      this.selectedUnitTypeId = ''
      this.rightTableData = []
      this.leftLoading = true
      const parameter = {
        standard_id: this.standardId,
        keyword: this.keyword,
        pageno: this.unitTypePageNo,
        pagesize: this.unitTypePageSize,
        sort: 'seq_no asc',
      }
      const res = await unitMeasureservice.unitTypeList(parameter)
      if (res && res.code === 0 && res.data) {
        this.leftTableData = res.data
        if (res.page) {
          this.unitTypeRecordCount = res.page.recordCount
          this.unitTypePageNo = res.page.pageNo
          this.unitTypePageSize = res.page.pageSize
        }
        this.leftLoading = false
        this.$nextTick(() => {
          if (this.$refs.leftTable) {
            this.$refs.leftTable.doLayout()
          }
        })
      }
    },
    leftDataActions() {
      if (!this.standardId) {
        this.$message({
          type: 'warning',
          message: this.$t('pleaseSelectAstandard'),
        })
        return
      }
      this.unitTypeDialog = true
      this.unitTypeTitle = this.$t('createUnitClass')
      this.unitTypeForm = {
        name: '',
        code: '',
        seqNo: 0,
      }
    },
    async editUnitType(id) {
      this.unitTypeDialog = true
      this.unitTypeTitle = this.$t('editUnitClass')
      if (this.$refs.unitTypeForm) {
        this.$refs.unitTypeForm.clearValidate()
      }
      const res = await unitMeasureservice.unitTypeDetail({ id })
      if (res && res.code === 0 && res.data) {
        this.unitTypeForm = res.data
      }
    },
    async viewUnitType(id) {
      this.unitTypeTitle = this.$t('viewUnitClass')
      this.unitTypeDialog = true
      if (this.$refs.unitTypeForm) {
        this.$refs.unitTypeForm.clearValidate()
      }
      const res = await unitMeasureservice.unitTypeDetail({ id })
      if (res && res.code === 0 && res.data) {
        this.unitTypeForm = res.data
      }
    },
    deleteUnitType(id) {
      this.$confirm(this.$t('whetherDeleteUnitClass'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      })
        .then(async () => {
          const res = await unitMeasureservice.unitTypeRemove({ data: [id] })
          if (res && res.code === 0) {
            this.$message({
              type: 'success',
              message: res.msg,
            })
            if (this.leftTableData.length === 1 && this.unitTypePageNo > 1) {
              this.unitTypePageNo -= 1
            }
            this.initLeftData()
          }
        })
        .catch(() => {})
    },
    closeUnitTypeDialog() {
      this.unitTypeDialog = false
    },
    saveUnitTypeData() {
      this.$refs.unitTypeForm.validate((valid) => {
        if (valid) {
          this.leftBtnLoading = true
          if (this.unitTypeTitle === this.$t('createUnitClass')) {
            this.unitTypeSave()
          } else {
            this.unitTypeUpdate()
          }
        }
      })
    },
    async unitTypeSave() {
      const parameter = {
        model: this.unitTypeForm,
      }
      parameter.model.standardId = this.standardId
      parameter.model.NoRepeatNames = ['code']
      const res = await unitMeasureservice.unitTypeCreate(parameter)
      if (res && res.code === 0) {
        this.$message({
          message: res.msg,
          type: 'success',
        })
        this.unitTypeDialog = false
        this.initLeftData()
      }
      this.leftBtnLoading = false
    },
    async unitTypeUpdate() {
      const parameter = {
        model: this.unitTypeForm,
      }
      parameter.model.standardId = this.standardId
      delete parameter.model.createdTime
      parameter.model.NoRepeatNames = ['code']
      const res = await unitMeasureservice.unitTypeUpdate(parameter)
      if (res && res.code === 0) {
        this.$message({
          message: res.msg,
          type: 'success',
        })
        this.unitTypeDialog = false
        this.initLeftData()
      }
      this.leftBtnLoading = false
    },
    unitTypeHandleCurrentChange(num) {
      this.unitTypePageNo = num
      this.initLeftData()
    },
    unitTypeHandleSizeChange(size) {
      this.unitTypePageSize = size
      this.initLeftData()
    },
    closeUnitDialog() {
      this.unitDialog = false
    },
    rightDataActions() {
      if (!this.selectedUnitTypeId) {
        this.$message({
          message: this.$t('pleaseSelectUnitClass'),
          type: 'warning',
        })
        return
      }
      this.unitForm = {
        seqNo: 0,
        name: '',
        code: '',
        symbol: '',
      }
      this.unitDialog = true
      this.unitTitle = this.$t('createUnit')
    },
    clickRightTableRow(obj) {
      this.selectedUnitTypeId = obj.id
      this.initRightData()
    },
    async initRightData() {
      this.rightLoading = true
      const parameter = {
        unitTypeId: this.selectedUnitTypeId,
        pageno: this.unitPageNo,
        pagesize: this.unitPageSize,
        sort: 'seq_no asc',
      }
      const res = await unitMeasureservice.unitList(parameter)
      if (res && res.code === 0 && res.data) {
        this.rightTableData = res.data
        if (res.page) {
          this.unitRecordCount = res.page.recordCount
          this.unitPageNo = res.page.pageNo
          this.unitPageSize = res.page.pageSize
        }
        this.rightLoading = false
        this.$nextTick(() => {
          if (this.$refs.rightTable) {
            this.$refs.rightTable.doLayout()
          }
        })
      }
    },
    async editUnit(id) {
      this.unitDialog = true
      this.unitTitle = this.$t('editUnit')
      if (this.$refs.unitForm) {
        this.$refs.unitForm.clearValidate()
      }
      const res = await unitMeasureservice.unitDetail({ id })
      if (res && res.code === 0 && res.data) {
        this.unitForm = res.data
      }
    },
    async viewUnit(id) {
      this.unitDialog = true
      this.unitTitle = this.$t('viewUnit')
      if (this.$refs.unitForm) {
        this.$refs.unitForm.clearValidate()
      }
      const res = await unitMeasureservice.unitDetail({ id })
      if (res && res.code === 0 && res.data) {
        this.unitForm = res.data
      }
    },
    saveUnitData() {
      this.$refs.unitForm.validate((valid) => {
        if (valid) {
          this.rightBtnLoading = true
          if (this.unitTitle === this.$t('createUnit')) {
            this.unitSave()
          } else {
            this.unitUpdate()
          }
        }
      })
    },
    async unitSave() {
      const parameter = {
        model: this.unitForm,
      }
      parameter.model.standardId = this.standardId
      parameter.model.unitTypeId = this.selectedUnitTypeId
      parameter.model.NoRepeatNames = ['code']
      const res = await unitMeasureservice.unitCreate(parameter)
      if (res && res.code === 0) {
        this.$message({
          message: res.msg,
          type: 'success',
        })
        this.unitDialog = false
        this.initRightData()
      }
      this.rightBtnLoading = false
    },
    async unitUpdate() {
      const parameter = {
        model: this.unitForm,
      }
      parameter.model.unitTypeId = this.selectedUnitTypeId
      parameter.model.NoRepeatNames = ['code']
      delete parameter.model.createdTime
      const res = await unitMeasureservice.unitUpdate(parameter)
      if (res && res.code === 0) {
        this.$message({
          message: res.msg,
          type: 'success',
        })
        this.unitDialog = false
        this.initRightData()
      }
      this.rightBtnLoading = false
    },
    deleteUnit(id) {
      this.$confirm(this.$t('whetherDeleteUnit'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      })
        .then(async () => {
          const res = await unitMeasureservice.unitRemove({ data: [id] })
          if (res && res.code === 0) {
            this.$message({
              type: 'success',
              message: res.msg,
            })
            if (this.rightTableData.length === 1 && this.unitPageNo > 1) {
              this.unitPageNo -= 1
            }
            this.initRightData()
          }
        })
        .catch(() => {})
    },
    unitHandleCurrentChange(num) {
      this.unitPageNo = num
      this.initRightData()
    },
    unitHandleSizeChange(size) {
      this.unitPageSize = size
      this.initRightData()
    },
  },
}
</script>
<style lang="scss" scoped>

/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}

</style>
